// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__IZp2X","savePackageButton":"ClientWallet_savePackageButton__11mgf"};